export default {

  _: "",
	AAAAA: "Downdog Splits Hip Dips",
  BBBBB: "Side Plank Tap-Out",
  CCCCC: "Child's Tiger",

  //  Standing
  DDDDD: "Hi Lunge Twist Curls",
  EEEEE: "Low Lunger Diggers",
  FFFFF: "Warrior 2 Sweep Thus",

  //Transition Moves
  GGGGG: "Warrior 3 Tucks",
  HHHHH: "Half Moon Curls",
  IIIII: "Lunge Spring Ups",
  JJJJJ: "Warrior 3 Blast Offs",

  //Squats
  KKKKK: "Sumo Cactus Taps",
  LLLLL: "Squat Punches",
  MMMMM: "Gold Digger",
  NNNNN: "Side Squat Curl Press",

  //Series 2 Sample Moves
  OOOOO: "Diagonal Kick Back Pyramid",
  PPPPP: "Pigeon Swing Arounds",

  //Single Combo Moves
  //HHHHH: "Half Moon Curls",
  QQQQQ: "Diagonal Kick Back Side Lunge",

  //Double Combo Moves
  RRRRR: "Super Crab",
  SSSSS: "Kicking Splits Pyramid",

  //All Fours Moves
  TTTTT: "Foot Behind Knee Kick Backs",
  UUUUU: "Kick Back Push-Up",
  VVVVV: "Blade Runner",
  WWWWW: "Side Lunge Plank Kick",
  XXXXX: "Side Kick Tap Back",
  YYYYY: "Buddhi Kicks",

  //Abs Moves Seated
  ZZZZZ: "Row Your Boat Crunches",
  ZAZA: "Straddle Plank Rollovers",
  ZBZB: "Reverse Table Taps",

  //Abs Moves Side Hip
  ZCZC: "Straight Leg Crunches",
  ZDZD: "Hip Lift Kicks",
  ZEZE: "High Kick Drop Backs",

  //Abs Moves Reclined
  ZFZF: "Stretch to Squat",
  ZGZG: "Crossed Ankle Leg Lifts",
  ZHZH: "Stretch to Tortoise Punch",

}



// WEBPACK FOOTER //
// ./src/directory.js